// (c) Copyright Mimic Networks, Inc. 2024
//
import React from 'react'
import { Select, Cascader } from 'antd'
import clsx from 'clsx'

const DropDown = ({
  options,
  defaultValue,
  onChange,
  placeholder,
  searcheable = false,
  label,
  permitMultiple = false,
  containerClassName = null,
  ...props
}) => {
  const filterOption = (input, option) => {
    return (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
  }

  const isCascade = options ? options.some((option) => option.children) : false
  const DropDownComponent = isCascade ? Cascader : Select

  const componentProps = {
    mode: permitMultiple ? 'multiple' : undefined,
    options: options,
    defaultValue: defaultValue,
    placeholder: placeholder,
    onChange: onChange,
    showSearch: searcheable,
  }

  if (searcheable) {
    componentProps.filterOption = filterOption
  }

  return (
    <div className={clsx(containerClassName, 'flex flex-col space-y-1')}>
      {label && <div className="text-xs">{label}</div>}
      <DropDownComponent {...componentProps} {...props} />
    </div>
  )
}

export default DropDown
